import MUITableRow, { TableRowProps } from "@material-ui/core/TableRow";

const TableRow = (props: TableRowProps) => <MUITableRow {...props} />;

export default TableRow;
